export default "__VITE_ASSET__BzwTCl5$__"